// extracted by mini-css-extract-plugin
export default {"FomBuilderContainer":"FormBuilderTool_FomBuilderContainer__QDcXE","FormCanvas":"FormBuilderTool_FormCanvas__XOBsZ","FormToolsContainer":"FormBuilderTool_FormToolsContainer__kjMun"};